import Head from "next/head"

interface Props {
  schema: {
    "@context": string
    "@type": string
  } & Record<string, unknown>
  id: string // Id for script reasons. Auto postfixed with 'schema' to help avoid overlap
}

// JSON-LD in Head so it is in the server HTML. The key is per id, so a page can render several schemas.
export const SchemaScript = ({ schema, id }: Props) => (
  <Head>
    <script
      key={id}
      id={`${id.endsWith("-schema") ? id.replace("-schema", "") : id}-schema`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  </Head>
)
